export default __webpack_public_path__ + "static/media/ic_linkedin.f21547d6.svg";